module.exports = __webpack_public_path__ + "img/product_82.22bb51b.webp";